<template>
  <Modal
    ref="compareValSessionsModal"
    :title="'Sessions to Compare'"
  >
    <!-- <template #modal-header /> -->
    <template #modal-main>
      <div class="settings container scrollbar">
        <HelpTip>
          View metrics for all selected validate sessions. Metrics are separated by columns, each column representing one session.
        </HelpTip>
        <div class="row mt-3">
          <div class="col-6 settings__control-group">
            <label class="required d-row">Sessions</label>
          </div>
        </div>
        <div class="row mb-3">
          <v-checkbox
            v-for="session in sessions"
            :key="session.id"
            v-model="selectedSesssions"
            :value="session.id"
            color="#250e81"
            :hide-details="true"
            :density="'compact'"
          >
            <template #label>
              <span class="checkbox-label"> {{ `(v-${Number(session.id).toString(16)})` }} {{ session.docker_task ? session.docker_task.name : '' }}</span>
            </template>
          </v-checkbox>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="footer">
        <button
          class="button modal-action-button"
          @click="compare"
        >
          Compare
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import SVGIcon from '@/components/SVGIcon.vue';
import { useToast } from 'vue-toast-notification';
import HelpTip from '../../HelpTip.vue';
import 'vue-toast-notification/dist/theme-sugar.css';

const $toast = useToast();

export default {
  name: 'CompareValidateSessionModal',
  components: {
    Modal,
    HelpTip,
  },
  props: {
    sessions: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['open-compare'],
  data() {
    return {
      selectedSesssions: [],
    };
  },
  mounted() {

  },
  methods: {
    showModal() {
      this.selectedSesssions = [];
      this.$refs.compareValSessionsModal.showModal();
    },
    compare() {
      if (this.selectedSesssions.length === 0) {
        $toast.open({
          queue: true,
          dismissible: true,
          message: `Select at least 1 validate session to compare results`,
          type: "error",
          position: "top",
        });
        return;
      }
      this.$emit('open-compare', this.selectedSesssions);
    },
  },
};

</script>

<style lang="scss" scoped>

.settings {
  padding: 0.75rem 3rem;
  min-width: 420px;
  max-height: 500px;
  overflow-y: auto;
}

.footer {
  display: flex;
  flex-direction: row;
  padding: 0.75rem 3rem;
  justify-content: flex-end;
}

.checkbox-label {
  margin-left: 10px;
  font-size: 0.9rem;
  font-weight: 600;
}

</style>
